import { getVoucherCode, getOnecomConfig } from "store/selectors";

const addToCart = (data) => (dispatch, getState) => {
  const state = getState();
  const coupon = getVoucherCode(state);
  const { currency } = getOnecomConfig(state) || {};
  const additionalData = { coupon, currency };

  // When tracking multiple products (e.g. bundle arrays),
  // then keep the payload an array, with the additional
  // data added to each item:
  if (Array.isArray(data)) {
    window.GTM.pushAddToCart(
      data.map((item) => ({ ...item, ...additionalData })),
    );
    return;
  }

  window.GTM.pushAddToCart({ ...data, ...additionalData });
};

export default addToCart;
